// const BACKEND_URL = "http://localhost:9000";
const BACKEND_URL = "https://medvault-backend.onrender.com";

const config = {
  url: {
    BACKEND: BACKEND_URL,
  },
};

export { config };
